import { Route } from "@angular/router";
import { MeusEmprestimosEmRSPage } from "./meus-emprestimos-em-rs.page";

export const MeusEmprestimosEmRsRouter: Route[] = [
  { path: 'meus-emprestimos-em-rs', component: MeusEmprestimosEmRSPage }
];
